module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('upload-multi-file', {
    attrs: {
      "name": "adjuntar_contratos_manuales",
      "folder": "contratos-sin-firmar",
      "onlyPdf": true
    },
    on: {
      "save": _vm.guardarAdjuntos,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjunte los pdf de las contratos")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Recuerda que los archivos deben tener el DNI al inicio del nombre del archivo")])])], 1) : _vm._e()]), (_vm.mostrarConfirmacionEliminarTodo) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminarTodo = false
      },
      "do": function($event) {
        return _vm.eliminar(null, null, true)
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar todas los contratos cargados?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar todo")])]), _c('strong', [_vm._v("Solo se eliminaran los contratos de la carga manual actual, no las generadas")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar(_vm.contrato.id, _vm.contrato)
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Está seguro que desea eliminar?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar")])])])], 1) : _vm._e(), (_vm.mostrarConfirmacionEnviarContratos) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    },
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEnviarContratos = false
      },
      "do": _vm.enviarContratos
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea enviar los contratos cargados?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Enviando...")]) : _c('span', [_vm._v("Enviar")])])])], 1) : _vm._e(), (_vm.mostrarErroresMultiples) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('errores-multiples', {
    attrs: {
      "errores": _vm.messages
    },
    on: {
      "close": function($event) {
        _vm.mostrarErroresMultiples = false
      }
    }
  })], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Carga manual de contratos")])]), _c('div', {
    staticClass: "display-flex filtros-completos jce"
  }, [_c('div', {
    staticClass: "text-right media-pt-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": _vm.openModalAdjuntar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload fs-12"
  })]), _c('span', [_vm._v("Adjuntar")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])])])]), _c('div', {
    staticClass: "mt-15"
  }, [_c('div', {
    staticClass: "text-right acciones-superior"
  }, [_c('button', {
    staticClass: "button is-small ml-5 mt-5 is-primary",
    attrs: {
      "disabled": _vm.lista.length === 0 || _vm.isLoading
    },
    on: {
      "click": _vm.confirmacionEnviarContratos
    }
  }, [_c('span', {
    staticClass: "icon is-small fs-13"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw fa-lg"
  })]), _c('span', [_vm._v("Enviar contratos")])]), _c('button', {
    staticClass: "button is-small is-danger ml-5 mt-5",
    attrs: {
      "disabled": _vm.lista.length === 0 || _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionEliminarTodo = true
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times fa-fw fa-lg"
  })]), _c('span', [_vm._v("Eliminar todo")])])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Nombre de archivo")]), _c('th', [_vm._v("Datos Contratos")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': o.isBGRed
      }
    }, [_c('td', [(o.codigoEmpleado) ? [_c('div', {
      staticClass: "d-initial"
    }, [_c('strong', [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dniObtenido))])]), _c('div', {
      staticClass: "display-flex hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigoEmpleado
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "cursor-pointer ml-5",
      attrs: {
        "title": "Desasignar empleado"
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.deasignarEmpleadoContratoAuxiliar(o)
        }
      }
    })])])] : [_c('div', {
      staticClass: "position-relative"
    }, [_c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleado),
        expression: "o.codigoEmpleado"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleado)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleado", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleado
      },
      on: {
        "selected": function($event) {
          return _vm.asignarEmpleadoContratoAuxiliar(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)]], 2), _c('td', [_c('div', [_vm._v(_vm._s(o.namefile))]), _c('div', {
      staticClass: "d-initial mt-10"
    }, [_c('strong', [_vm._v("Modificado: ")]), _c('span', [_vm._v(_vm._s(o.modificado))])])]), _c('td', [_c('div', {
      staticClass: "flex fdc"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": o.indeterminado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    }), _c('label', [_vm._v(" Indeterminado")])]), _c('hr', {
      staticClass: "margin-05-rem"
    }), _c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label date-input"
    }, [_vm._v("Inicio")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaInicio),
        expression: "o.fechaInicio"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "disabled": o.indeterminado
      },
      domProps: {
        "value": (o.fechaInicio)
      },
      on: {
        "blur": function($event) {
          return _vm.checkDates(o)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaInicio", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label date-input"
    }, [_vm._v("Fin")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaFin),
        expression: "o.fechaFin"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "disabled": o.indeterminado
      },
      domProps: {
        "value": (o.fechaFin)
      },
      on: {
        "blur": function($event) {
          return _vm.checkDates(o)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaFin", $event.target.value)
        }
      }
    })])])]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones fdc"
    }, [(o.ruta) ? _c('a', {
      staticClass: "margin-acciones button is-small",
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])]) : _vm._e(), _c('button', {
      staticClass: "margin-acciones button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o.id, o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])]), _c('button', {
      staticClass: "margin-acciones button is-small",
      on: {
        "click": function($event) {
          return _vm.verVistaPrevia(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Vista previa")])])])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      class: {
        'is-close': !o.codigoEmpleado || o.isBGRed
      }
    }, [(o.codigoEmpleado) ? [_c('div', [_c('strong', [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dniObtenido))])]), _c('div', {
      staticClass: "descripcion-tipo display-flex"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "cursor-pointer ml-5",
      attrs: {
        "title": "Desasignar empleado"
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.deasignarEmpleadoContratoAuxiliar(o)
        }
      }
    })])])] : [_c('div', {
      staticClass: "mb-10"
    }, [_c('div', {
      staticClass: "position-relative"
    }, [_c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleado),
        expression: "o.codigoEmpleado"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleado)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleado", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleado
      },
      on: {
        "selected": function($event) {
          return _vm.asignarEmpleadoContratoAuxiliar(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)])], _c('div', {
      staticClass: "motivo"
    }, [_c('span', [_vm._v(_vm._s(o.namefile))])]), _c('div', {
      staticClass: "dias-pedidos mt-5"
    }, [_c('strong', [_vm._v("Fecha de modificación: ")]), _c('div', [_vm._v(_vm._s(o.modificado))]), _c('div', {
      staticClass: "flex fdc"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": o.indeterminado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    }), _c('label', [_vm._v(" Indeterminado")])]), _c('hr', {
      staticClass: "margin-05-rem"
    }), _c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label date-input"
    }, [_vm._v("Inicio")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaInicio),
        expression: "o.fechaInicio"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "disabled": o.indeterminado
      },
      domProps: {
        "value": (o.fechaInicio)
      },
      on: {
        "blur": function($event) {
          return _vm.checkDates(o)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaInicio", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label date-input"
    }, [_vm._v("Fin")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaFin),
        expression: "o.fechaFin"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "disabled": o.indeterminado
      },
      domProps: {
        "value": (o.fechaFin)
      },
      on: {
        "blur": function($event) {
          return _vm.checkDates(o)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaFin", $event.target.value)
        }
      }
    })])])]), _c('div', {
      staticClass: "botones"
    }, [(o.ruta) ? _c('a', {
      staticClass: "button margin-acciones is-small",
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])]) : _vm._e(), _c('button', {
      staticClass: "button is-small is-danger margin-acciones",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o.id, o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])]), _c('button', {
      staticClass: "margin-acciones button is-small",
      on: {
        "click": function($event) {
          return _vm.verVistaPrevia(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _c('span', [_vm._v("Vista previa")])])])], 2)
  })], 2)] : _vm._e()], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a4648f8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Contratos_Carga_Manual.vue
// module id = 865
// module chunks = 0